import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export type SectionsMode = "both" | "events" | "spots";
const EV = "wn:sections";
let cache: SectionsMode | null = null;
let pending: Promise<void> | null = null;

const fetchMode = () => (pending ??= api.get("/platform/sections").then((r) => { cache = r.data.mode; window.dispatchEvent(new Event(EV)); }).catch(() => { cache = cache || "both"; }).finally(() => { pending = null; }));

export const setSectionsCache = (m: SectionsMode) => { cache = m; window.dispatchEvent(new Event(EV)); };

export function useSections() {
  const [mode, setMode] = useState<SectionsMode | null>(cache);
  useEffect(() => {
    const h = () => setMode(cache);
    window.addEventListener(EV, h);
    fetchMode();
    return () => window.removeEventListener(EV, h);
  }, []);
  return { mode, events: mode !== "spots", spots: mode !== "events" };
}
